module.exports = __webpack_public_path__ + "static/media/logo.499036bc.png";